import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllData } from '../services/syncService';
import { closeDB } from '../config/db';
import Swal from 'sweetalert2';
import timesheetSyncService from '../services/timesheetSyncService';

function useAuth() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuthentication = () => {
            const token = localStorage.getItem('token');
            if (token) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
                if (navigator.onLine) {
                    navigate('/#login');
                }
            }
        };

        checkAuthentication();

        window.addEventListener('online', checkAuthentication);
        window.addEventListener('offline', checkAuthentication);

        return () => {
            window.removeEventListener('online', checkAuthentication);
            window.removeEventListener('offline', checkAuthentication);
        };
    }, [navigate]);

    const handleLogout = async () => {
        // Выход стирает базу устройства. Неотправленные часы/заметки/подписи
        // пропали бы молча — сначала пробуем отправить, не вышло — предупреждаем.
        let unsent = 0;
        try {
            unsent = await timesheetSyncService.countUnsent();
            if (unsent > 0) {
                Swal.fire({ title: 'Sending your hours…', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
                unsent = await timesheetSyncService.flushBeforeLogout();
                Swal.close();
            }
        } catch (e) {
            console.warn('[Auth] unsent check failed:', e);
        }
        if (unsent > 0) {
            const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
            const res = await Swal.fire({
                icon: 'warning',
                title: 'Hours not sent to the office',
                html: `${unsent} timesheet ${unsent === 1 ? 'change has' : 'changes have'} not been sent yet`
                    + (offline ? ' — this device is offline.' : '.')
                    + '<br><br>If you log out now, <b>they will be deleted from this device and lost</b>.'
                    + '<br>Stay logged in, open Timesheet with internet and wait until it says everything is sent.',
                showCancelButton: true,
                confirmButtonText: 'Stay logged in',
                cancelButtonText: 'Log out anyway',
                reverseButtons: true,
                focusConfirm: true,
                confirmButtonColor: '#16a34a',
                cancelButtonColor: '#dc2626',
            });
            if (!res.dismiss || res.dismiss !== Swal.DismissReason.cancel) return;
        }
        console.log('[Auth] Logging out...');
        setIsAuthenticated(false);
        closeDB(); // Закрываем соединение к БД и останавливаем keep-alive таймер
        clearAllData();
        localStorage.clear();
        navigate('/#login');
    };

    return { isAuthenticated, handleLogout };
}

export default useAuth;
